import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const TrustpilotSkeleton = ()=>{
    const isEditing = useIsEditing();
    return /*#__PURE__*/ _jsx("div", {
        "data-component": "authorable/shared/content/TrustpilotReviews",
        ...editingHydrationProps(isEditing),
        className: "scroll-mt-[64px] md:scroll-mt-0 animate-pulse",
        "aria-busy": "true",
        "aria-label": "Loading Trustpilot reviews",
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full bg-component-section-bg relative before:z-[-1] before:h-full before:absolute before:bg-component-section-bg before:top-0 before:left-[calc(-50vw+50%)] before:right-[calc(-50vw+50%)] py-component-section-container-padding-y",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center gap-component-section-container-padding-y lg:gap-component-section-container-gutter w-full",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end gap-space-between-tight",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-5 w-36 bg-gray-200 rounded"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-9 w-[147px] bg-gray-200 rounded"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-space-between-base max-w-columns-two-third-max-width justify-center mx-auto w-full",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-8 bg-gray-200 rounded w-3/4 mx-auto max-w-[280px]"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "w-component-section-divider-width h-component-section-divider-height bg-gray-200 rounded mx-auto"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-wrap items-center justify-center gap-spacing-spacing-16",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-5 w-20 bg-gray-200 rounded"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex gap-[4px]",
                                children: [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ].map((i)=>/*#__PURE__*/ _jsx("div", {
                                        className: "w-6 h-6 bg-gray-200 rounded"
                                    }, i))
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-5 w-40 bg-gray-200 rounded"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col lg:flex-row gap-layout-base-gutter w-full",
                        children: [
                            1,
                            2,
                            3
                        ].map((i)=>/*#__PURE__*/ _jsxs("div", {
                                className: "bg-[#FDFDFD] [box-shadow:0_0_8px_0_var(--color-black-alpha-10,rgba(0,0,0,0.10))] rounded-general-border-radius-card p-padding-base flex flex-col gap-spacing-spacing-24 flex-1 text-left",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex gap-[4px]",
                                        children: [
                                            1,
                                            2,
                                            3,
                                            4,
                                            5
                                        ].map((j)=>/*#__PURE__*/ _jsx("div", {
                                                className: "w-6 h-6 bg-gray-200 rounded"
                                            }, j))
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "space-y-2 flex-1",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "h-4 bg-gray-200 rounded w-full"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "h-4 bg-gray-200 rounded w-5/6"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-col gap-[2px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "h-4 bg-gray-200 rounded w-32"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "h-3 bg-gray-200 rounded w-20"
                                            })
                                        ]
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex justify-center w-full",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "h-12 w-64 bg-gray-200 rounded-general-border-radius-button"
                        })
                    })
                ]
            })
        })
    });
};
export default TrustpilotSkeleton;
